import { RatingTypeEnum } from 'types/api/enums'
import { Option, SortingDirection, SortingField } from 'types/global'
import { WTN_SCALE_HIGH, WTN_SCALE_LOW } from './global'
import moment from 'moment'
import { SearchFilters } from 'reducers/search-reducer'
import i18next from '../i18n'

export const DEFAULT_TABLE_SORTING = {
  field: SortingField.WTNSingles,
  direction: SortingDirection.ASC,
}

export const DEFAULT_PLAYER_SEARCH_FILTERS: SearchFilters = {
  rating: {
    type: RatingTypeEnum.ITF,
    range: {
      min: WTN_SCALE_HIGH,
      max: WTN_SCALE_LOW,
    },
    confidence: true,
  },
}

const createYearBasedAgeGroups = () => {
  const currentYear = moment().year() - 14
  const ageGroups: Option[] = []

  for (let i = 0; i < 7; i++) {
    ageGroups.push({
      value: `${currentYear - i}`,
      label: i18next.t('ageGroupBornInLabel', { ns: 'strFilterBar', birthYear: currentYear - i }),
    })
  }

  return ageGroups
}

export const AGE_GROUPS = [
  { value: 'UNDER_14', label: 'Under 14' },
  ...createYearBasedAgeGroups(),
  { value: '20_30', label: '20 - 30' },
  { value: '31_40', label: '31 - 40' },
  { value: '41_50', label: '41 - 50' },
  { value: 'OVER_50', label: '50+' },
]
